export default __webpack_public_path__ + "static/media/catamaran.d1d0de2d.png";